import React from 'react'
import { css } from '@emotion/react'
import cn from 'classnames'
import styled from '@emotion/styled'
import themeVars from 'ui_theme/site/globals/site.variables'

import { propFunc } from 'util/functions'
import { emptyArr } from 'util/arrays'

import RemovableRecipient from './RemovableRecipient'
import AddContact from './AddContact'

const OldList = ({
  allowMultipleRecipients,
  className,
  recipients = emptyArr,
  onRemove,
  startEditing,
  type,
  children,
}) => {
  const showAddContact =
    (allowMultipleRecipients || recipients.length === 0) && startEditing
  return (
    <div
      className={cn('grui flex flex-auto', className)}
      css={css`
        width: 100%;
        gap: 6px 0;
      `}
    >
      {recipients.map(recipient => {
        return (
          <RemovableRecipient
            className="recipient"
            key={recipient.id || recipient.email}
            user={recipient}
            allUsers={recipients}
            onClick={propFunc(onRemove, recipient, type)}
          />
        )
      })}
      {showAddContact && (
        <AddContact className="addContact" onClick={startEditing} />
      )}
      {children}
    </div>
  )
}

const OldStyledList = styled(OldList)`
  flex-wrap: wrap;
  align-items: center;
  line-height: 32px;

  .recipient {
    display: flex;
    margin-right: 4px;
  }

  .addContact:not(:only-child) {
    margin-left: ${props => props.theme.spacing['4']};
    opacity: 0;
    transition: opacity 300ms ease;
  }

  :hover .addContact {
    opacity: 1;
  }
`

const SpacedListStyle = props => css`
  padding: 11px 16px;
  border-radius: ${themeVars.defaultBorderRadius};
  border: 1px solid
    ${props.focused
      ? props.theme.color.primary.brand
      : props.theme.color.monochrome.medium};
  background-color: white;
`

const StyledList = styled('div')`
  width: 100%;
  flex-wrap: wrap;
  align-items: center;

  & > *:not(:last-child) {
    margin-right: ${props => props.theme.spacing['5']};
  }

  ${props => !props.unspacedStyle && SpacedListStyle};
`

function SUIList(props) {
  const {
    allowMultipleRecipients,
    children,
    focused,
    onRemove,
    recipients,
    startEditing,
    type,
    unspacedStyle = false,
  } = props

  const showAddTrigger =
    (allowMultipleRecipients || recipients.length === 0) && startEditing

  return (
    <StyledList
      className="grui flex flex-auto"
      focused={focused}
      unspacedStyle={unspacedStyle}
    >
      {recipients.map(recipient => {
        return (
          <RemovableRecipient
            css={css`
              margin-bottom: 0;
            `}
            className="recipient"
            key={recipient.id || recipient.email}
            user={recipient}
            allUsers={recipients}
            onClick={propFunc(onRemove, recipient, type)}
          />
        )
      })}
      {showAddTrigger && (
        <div
          css={css`
            flex-grow: 1;
            height: 100%;
            min-height: 18px;
            cursor: pointer;
          `}
          onClick={startEditing}
        />
      )}
      {children}
    </StyledList>
  )
}

export default function List(props) {
  const { sui, ...rest } = props

  if (sui) return <SUIList {...rest} />

  return <OldStyledList {...rest} />
}
